import { ENTRY_LAYOUT } from './TransactionsTimeline'

const TransactionsTimelineSkeleton = ({ rows = 3 }) => (
  <div className="positions-timeline positions-timeline--skeleton relative">
    <span aria-hidden="true" className="positions-timeline__rail absolute left-[5px] top-3 bottom-3 w-px bg-Neutral-3" />

    <div className="positions-timeline__day-label skeleton rounded-2xl h-3 w-24 ml-9 mt-4 mb-1" />

    {Array.from({ length: rows }).map((_, index) => (
      <div key={`timeline-skeleton-${index}`} className="positions-timeline__entry relative pl-9 py-3">
        <span
          aria-hidden="true"
          className="positions-timeline__dot skeleton absolute left-0 top-[22px] h-[11px] w-[11px] rounded-full ring-4 ring-surface-1"
        />
        <div className={`positions-timeline__entry-grid ${ENTRY_LAYOUT}`}>
          <div className="skeleton rounded-2xl h-3 w-10" />
          <div className="skeleton rounded-2xl h-4 w-14" />
          <div className="skeleton rounded-2xl h-4 w-40" />
          <div className="skeleton rounded-2xl h-3 w-32" />
          <div className="skeleton rounded-2xl h-4 w-20" />
        </div>
      </div>
    ))}
  </div>
)

export default TransactionsTimelineSkeleton
